export class BlogPostSummary {
  public id: string | undefined = undefined;
  public title: string | undefined = undefined;
  public excerpt: string | undefined = undefined;
  public mediaUrl: string | undefined = undefined;
  public creationDate: Date | undefined = undefined;
}
